import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import ZoneChart from "./ZoneChart";

type Zone = {
    x: string,
    y: number,
    id: string
}
export default function ZoneCharts(){
    const [distrito, setDistrito] = useState<Zone>();

    return(
        <>
            <Row className="justify-content-center">
                <Col xs={12} md={12 / (distrito ? 2 : 1)}>
                    <ZoneChart setHook={setDistrito} />
                </Col>
                {
                    distrito &&
                    <Col xs={12} md={6}>
                        <ZoneChart district={distrito} setHook={setDistrito} />
                    </Col>
                }
            </Row>
        </>
    )
}